// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__K1ykg","sidebarActive":"Sidebar_sidebarActive__jiogq"};